(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const hash = url.hash.slice(1);
        const card = document.getElementById(hash);
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
          return;
        }

        const seriesTargets = {
          'sensitive-series': 'For Sensitive Series',
          'anti-aging-series': 'For Anti-Aging Series',
          'brightening-series': 'For Brightening Series',
          'moisturizing-series': 'For Moisturizing Series',
          'acne-care-series': 'For Acne Care Series',
          'sun-protection-series': 'For Sun Protection Series',
        };
        const targetText = seriesTargets[hash];

        if (targetText) {
          const target = [...document.querySelectorAll('h1, h2, h3, p, .text-block')]
            .find((element) => element.textContent.trim().includes(targetText));
          const section = target?.closest('.shopify-section, section, .section');

          if (section) {
            section.scrollIntoView({ behavior: 'instant', block: 'start' });
          }
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
